@if (hasFreight) {

  <ion-item>

    <ion-label>
      <div class="title">{{ 'ITEMS.PURCHASES.SHIPPING' | translate }}</div>
    </ion-label>

    <ion-note slot="end">
      <ion-input
        placeholder="0"
        type="number"
        inputmode="decimal"
        [readonly]="!canEditFreight"
        [(ngModel)]="freight"
        (ngModelChange)="freightChange.emit(freight)"
        (ionBlur)="saveAmountData.emit()"
      >
        <ion-note class="input-note" slot="end">€</ion-note>
      </ion-input>
    </ion-note>

  </ion-item>

  <ion-item>

    <ion-label>
      <div class="title">{{ 'ITEMS.PURCHASES.FREIGHT_VAT' | translate }}</div>
    </ion-label>

    <ion-note slot="end" (click)="clickFreightIVA.emit()">{{ freightIVA }} %</ion-note>

  </ion-item>

}

@if (hasDiscount) {

  <ion-item>

    <ion-label (click)="canEditDiscount && toggleDiscountType()">
      <div class="title">
        {{ (!isDiscountByAmount ? 'ITEMS.PURCHASES.DISCOUNT' : 'ITEMS.PURCHASES.DISCOUNT_ABS') | translate }}

        @if (canEditDiscount) {
          <yu-icon name="arrows-left-right"></yu-icon>
        }
      </div>
    </ion-label>

    <ion-note slot="end">

      @if (!isDiscountByAmount) {

        <ion-input
          placeholder="0"
          type="number"
          inputmode="decimal"
          [readonly]="!canEditDiscount"
          [(ngModel)]="discount"
          (ngModelChange)="discountChange.emit(discount)"
          (ionBlur)="saveAmountData.emit()"
        >
          <ion-note class="input-note" slot="end">%</ion-note>
        </ion-input>

      } @else {

        <ion-input
          placeholder="0"
          type="number"
          inputmode="decimal"
          [readonly]="!canEditDiscount"
          [(ngModel)]="discountAbs"
          (ngModelChange)="discountAbsChange.emit(discountAbs)"
          (ionBlur)="saveAmountData.emit()"
        >
          <ion-note class="input-note" slot="end">€</ion-note>
        </ion-input>

      }

    </ion-note>

  </ion-item>

}

@if (alternativeTaxes) {

  <ion-item>

    <ion-label>
      <div class="title">{{ 'ITEMS.PURCHASES.ALTERNATIVE_TAXES' | translate }}</div>
    </ion-label>

    <ion-note slot="end">
      {{ (alternativeTaxes | currency: "EUR": "symbol": "1.2-2": "es") || '- €' }}
    </ion-note>

  </ion-item>

}

@if (minimum) {

  <ion-item>

    <ion-label>
      <div class="title">{{ 'ITEMS.PURCHASES.MINIMUM_COST' | translate }}</div>

      @if (minimum > subtotal) {
        <yu-helper icon="warning" color="error">
          {{ 'ITEMS.PURCHASES.MINIMUM_COST_NOT_REACHED' | translate }}
        </yu-helper>
      }
    </ion-label>

    <ion-note slot="end">
      {{ (minimum | currency: "EUR": "symbol": "1.2-2": "es") || '- €' }}
    </ion-note>

  </ion-item>

}

<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.PURCHASES.SUBTOTAL' | translate }}</div>

    @if (alertPrice) {
      <yu-helper icon="warning" color="error">
        {{ 'ITEMS.PURCHASES.MISSING_PRODUCTS_PRICE' | translate }}
      </yu-helper>
    }
  </ion-label>

  <ion-note slot="end">
    {{ (subtotal | currency: "EUR": "symbol": "1.2-2": "es") || '- €' }}
  </ion-note>

</ion-item>

@if (vats && vats.length > 0) {

  <ion-accordion-group>

    <ion-accordion toggleIconSlot="">

      <ion-item slot="header" lines="none">
        <ion-label>
          <div class="title">IVA</div>
        </ion-label>

        <ion-note slot="end">{{ ((total - subtotal) | currency: "EUR":"symbol":"1.2-2":"es") || '- €' }}</ion-note>
      </ion-item>

      <ion-list slot="content" lines="none">

        @for (vat of vats | sortBy: ['iva']: 'asc'; track vat.id) {

          <ion-item>
            <ion-label class="title">{{ vat.iva }}%</ion-label>

            <ion-note slot="end">{{ (vat.total | currency: "EUR":"symbol":"1.2-2":"es") || '- €' }}</ion-note>
          </ion-item>

        }

      </ion-list>

    </ion-accordion>

  </ion-accordion-group>

}

<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.PURCHASES.TOTAL' | translate }}</div>

    @if (alertPrice) {
      <yu-helper icon="warning" color="error">
        {{ 'ITEMS.PURCHASES.MISSING_PRODUCTS_VAT' | translate }}
      </yu-helper>
    }
  </ion-label>

  <ion-note class="total" slot="end">
    {{ (total | currency: "EUR": "symbol": "1.2-2": "es") || '- €' }}
  </ion-note>

</ion-item>
